import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pageData: {},
  pageFlag: 'create'
}

export const socialTypeSlice = createSlice({
  name: 'socialType',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setSocialTypeDataAction: (state, action) => {
      state.pageData = action.payload
    },
    setSocialTypePageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setSocialTypeDataAction, setSocialTypePageFlagAction } = socialTypeSlice.actions


// Selectors
export const selectSocialTypeData = (state) => state.socialType.pageData
export const selectSocialTypePageFlag = (state) => state.socialType.pageFlag

// Reducer
export default socialTypeSlice.reducer